
import { defineComponent, PropType } from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { useModal } from '~/composables/useModal';
import { IAccessoryProperties } from '~/types/fightcamp';

export default defineComponent({
  name: 'PackageIncludedCarousel',
  components: {
    FCImage,
  },
  props: {
    packageName: {
      type: String,
      required: true,
    },
    includeProducts: {
      type: Array as PropType<IAccessoryProperties[]>,
      required: true,
    },
  },
  setup() {
    function openAllIncludedModal(product?: IAccessoryProperties) {
      if (!product) return;

      const componentProps = {
        activeProduct: product,
        packageName: product.productName,
      };

      const { modalShow } = useModal({
        component: () => import('../AllIncludedModal.vue'),
        componentProps,
        modalProps: {
          componentName: 'AllIncludedModal',
          adaptive: true,
          width: '95%',
          maxWidth: 1200,
          height: 'auto',
          maxHeight: 900,
        },
      });

      modalShow();
    }

    function getImageProperties(product: IAccessoryProperties) {
      return {
        src: product?.primaryImg?.src,
        alt: product?.primaryImg?.alt,
        sizes: 'sm:160px lg:320px',
        loading: 'eager',
      };
    }

    return {
      openAllIncludedModal,
      getImageProperties,
    };
  },
});
